export default {
  en: {
    heading: 'Free practice',
  },
  ru: {
    heading: 'Свободная практика',
  },
  de: {
    heading: 'Freie Übung',
  },
  pt: {
    heading: 'Prática livre',
  },
  fr: {
    heading: 'Pratique libre',
  },
  es: {
    heading: 'Práctica libre',
  },
};
